export default state => `
<footer>
  &copy; Alexander Rice
</footer>
`;
